import useMediaQueries from '@stone/hooks/useMediaQueries';
import React from 'react';
import ClientServiceStepsMobile from './ClientServiceStepsMobile';
import ClientServiceStep from './ClientServiceStep';
const ClientServiceSteps = (props) => {
    const _steps = typeof props.steps === 'string' ? JSON.parse(props.steps) : props.steps;
    const { isMobile } = useMediaQueries();
    return isMobile ? (React.createElement(ClientServiceStepsMobile, { componentid: props.componentid, steps: _steps })) : (React.createElement("div", { className: "cs-step_group" }, _steps.map((step, _i) => (React.createElement(ClientServiceStep, Object.assign({ key: _i }, step))))));
};
export default ClientServiceSteps;
